import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var ArrowDownOutlineSVG = function ArrowDownOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M24.69,17.19h0a1,1,0,0,0-1.48,0L17,23.5V6a1,1,0,1,0-2,0V23.5L8.79,17.19a1,1,0,0,0-1.48,0h0a1.07,1.07,0,0,0,0,1.5l7.89,8A1.09,1.09,0,0,0,16,27a1.13,1.13,0,0,0,.8-.31l7.89-8A1.07,1.07,0,0,0,24.69,17.19Z"
  }));
};
ArrowDownOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ArrowDownOutlineSVG);